import { ExperimentTemplateData } from '@experiment-details/types';
import { experimentDetailsViewsStoreV2 } from '@shared';
import { AUTO_GENERATED_OPTION_ID } from '@shared/constants';
import { noop } from 'lodash';

export const getExpDetailsLocalTemplates = async (
  projectId: string
): Promise<ExperimentTemplateData[]> => {
  const rows = await experimentDetailsViewsStoreV2
    .where({ projectId })
    .toArray()
    .catch(() => []);

  return rows.map(row => row.templateData);
};

export const saveTemplateLocally = async (template: ExperimentTemplateData) => {
  await experimentDetailsViewsStoreV2
    .put({
      projectId: template.projectId,
      templateData: {
        ...template,
        lastUpdatedAt: new Date().getTime(),
        isLocalTemplate: true
      },
      templateId: template.templateId || AUTO_GENERATED_OPTION_ID
    })
    .catch(noop);
};

export const removeExpDetailsLocalTemplate = (
  projectId: string,
  templateId: string | null
) =>
  experimentDetailsViewsStoreV2
    .delete([projectId, templateId || AUTO_GENERATED_OPTION_ID])
    .catch(noop);

export const findExpDetailsLastVersionTemplate = (
  remoteTemplate: ExperimentTemplateData,
  localTemplates: ExperimentTemplateData[]
) => {
  const localTemplate = localTemplates.find(
    temp => temp.templateId === remoteTemplate?.templateId
  );

  if (!localTemplate) return remoteTemplate;

  return getLastUpdatedExpTemplate(remoteTemplate, localTemplate);
};

export const getLastUpdatedExpTemplate = (
  templateA: ExperimentTemplateData,
  templateB: ExperimentTemplateData
): ExperimentTemplateData => {
  const lastUpdateA = templateA?.lastUpdatedAt || 0;
  const lastUpdateB = templateB?.lastUpdatedAt || 0;

  return lastUpdateB > lastUpdateA ? templateB : templateA;
};
